import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerCheckoutDomainService,
  ProviderCheckoutDomainRequestError,
} from '@/services/provider/checkout-domain.service';
import type {
  ProviderCheckoutDomainSettings,
  UpdateProviderCheckoutDomainInput,
} from '@/types/provider-checkout-domain';

export const providerCheckoutDomainKeys = {
  all: ['provider', 'settings', 'checkout-domain'] as const,
  detail: () => [...providerCheckoutDomainKeys.all, 'detail'] as const,
};

export function useProviderCheckoutDomainSettings(enabled = true) {
  return useQuery<ProviderCheckoutDomainSettings, ProviderCheckoutDomainRequestError>({
    queryKey: providerCheckoutDomainKeys.detail(),
    queryFn: () => providerCheckoutDomainService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderCheckoutDomainSettings() {
  const queryClient = useQueryClient();

  return useMutation<
    ProviderCheckoutDomainSettings,
    ProviderCheckoutDomainRequestError,
    UpdateProviderCheckoutDomainInput
  >({
    mutationFn: (input) => providerCheckoutDomainService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerCheckoutDomainKeys.detail(), settings);
    },
  });
}
